export default {
  header: 'Ordreoversigt',
  buttons: {
    checkout: 'Sikker betaling',
    continue: 'Fortsæt',
    add_products: '+ Tilføj produkter',
    add_items: '+ Tilføj flere varer',
    menu: 'Menu',
  },
  empty_order_basket: {
    description: 'Din kurv er tom <br/> Tilføj varer for at komme i gang',
  },
  promo_code_banner: {
    single_use: '{{discount}} rabat - {{code}}',
    multi_use: '{{discount}} rabat på {{count}} ordrer - {{code}}',
    redeem: 'INDLØS',
    redeemed: 'INDLØST',
  },
  upsell: {
    title: 'Andre bestiller også',
  },
  rewards: {
    title: 'Betal med point',
    description: '<highlight>Log ind</highlight> for at betale med point',
  },
  already_member: 'Allerede medlem?',
  sign_in: 'Log ind',
  summary: {
    subtotal: 'Subtotal',
    delivery: 'Levering',
    pickup: 'Afhentning',
    total: 'I alt',
    free: 'Gratis',
  },
  footer: {
    member_earning: '+{{points}} point efter betaling · {{balance}} point i saldo',
    guest_earning: 'Opret en konto for at begynde at optjene point på denne ordre',
  },
};
